import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const NoValidIcon = ({ width = "96", height = "96" }: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="96" height="96" rx="48" fill="#FFF3EB" />
        <rect x="16" y="16" width="64" height="64" rx="32" fill="#FFE7D7" />
        <path
          d="M55.5427 51.7712L53.6571 49.8856L55.5427 48C57.6255 45.9172 57.6255 42.5404 55.5427 40.4576C53.4599 38.3748 50.0829 38.3748 48.0001 40.4576L46.1145 42.3432L44.2289 40.4576L46.1145 38.5719C49.2388 35.4477 54.3041 35.4477 57.4283 38.5719C60.5524 41.6961 60.5524 46.7615 57.4283 49.8856L55.5427 51.7712ZM51.7715 55.5425L49.8857 57.4281C46.7616 60.5523 41.6963 60.5523 38.5721 57.4281C35.4479 54.3039 35.4479 49.2385 38.5721 46.1144L40.4577 44.2288L42.3433 46.1144L40.4577 48C38.3749 50.0828 38.3749 53.4597 40.4577 55.5425C42.5405 57.6253 45.9173 57.6253 48.0001 55.5425L49.8857 53.6569L51.7715 55.5425ZM51.7715 42.3432L53.6571 44.2288L44.2289 53.6569L42.3433 51.7712L51.7715 42.3432ZM39.7005 35.0572L42.2763 34.367L43.6567 39.5186L41.0809 40.2088L39.7005 35.0572ZM52.3437 56.4815L54.9195 55.7912L56.2999 60.9428L53.724 61.6331L52.3437 56.4815ZM35.0574 39.7004L40.209 41.0807L39.5188 43.6565L34.3672 42.2762L35.0574 39.7004ZM56.4816 52.3435L61.6332 53.7239L60.9429 56.2997L55.7913 54.9193L56.4816 52.3435Z"
          fill="#CB6D2B"
        />
      </svg>
    </IconWrapper>
  );
};
